// extracted by mini-css-extract-plugin
export default {"tooltip":"_2vcyM"};